<footer>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-sm-5 col-lg-4">
                <p>
                    <a target="_blank" routerLink="/privacy-and-policy">Privacy Policy</a>
                    <a target="_blank" routerLink="/terms-and-condition">Terms & Conditions</a>
                </p>
            </div>
            <div class="col-sm-2 col-lg-4"><img src="assets/images/logo.svg" alt="" class="logo text-center" /></div>
            <div class="col-sm-5 col-lg-4 text-right">
                <p class="text-end">{{Global.APP_NAME}} {{Global.CURRENT_YEAR}} | All Rights Reserved</p>
            </div>
        </div>
    </div>
</footer>